import React, { useState, useEffect } from 'react'
import MainModalContent from '../components/mainModalContent'
import EmployerModalContent from '../components/employerModalContent'
import PartnerModalContent from '../components/partnerModalContent'
import JobseekerModalContent from '../components/jobseekerModalContent'
import HiringButton from '../components/hiringButton'
import SocialIcons from '../components/socialIcons'

const Hiring = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalContent, setModalContent] = useState(null)

  const openModal = (e) => {
    e.preventDefault()
    setModalContent(<MainModalContent setModalContent={setModalContent} />)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  useEffect(() => {
    if (modalContent === 'employer') {
      setModalContent(<EmployerModalContent />)
    } else if (modalContent === 'partner') {
      setModalContent(<PartnerModalContent />)
    } else if (modalContent === 'jobseeker') {
      setModalContent(<JobseekerModalContent />)
    }
  }, [modalContent])

  return (
    <>
      <div className="bg-cover bg-top bg-no-repeat h-1/4" style={{ backgroundImage: 'url(/images/hiring.png)' }}>
        <div className="tl-container flex flex-col lg:flex-row justify-between items-center mt-4 space-y-8 lg:space-y-0">
          <div className="w-full lg:w-1/3 text-white p-4 text-center lg:text-left">
            <h1 className="text-headline lg:text-display-md mb-4">We are waiting to hear from you!</h1>
            <div className="flex space-x-6 justify-center lg:justify-start">
              <SocialIcons iconColor="text-white" iconHover="text-grey30" iconSize="fa-lg" />
            </div>
          </div>
          <div className="w-full lg:w-1/2 text-white text-center p-4">
            <div className="max-w-sm lg:max-w-lg mx-auto">
              <HiringButton hiring={true} />
            </div>

            {/* <p className="text-body-sm max-w-full lg:max-w-lg mx-auto text-left overflow-hidden break-words leading-relaxed">
            Hire Talent. Transform Lives. 
            </p> */}
            <p className="text-body-lg font-medium max-w-full lg:max-w-lg mx-auto text-left overflow-hidden break-words leading-relaxed">
              Find talented candidates from our global, diverse and displaced talent pool who are ready to relocate.
              With TalentLift, finding talent is transformative.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default Hiring
